import { ATOL } from '../../constants/ui'
import { getSessionToken, setSessionToken } from '../../utils/persistance'

import { Navigate } from 'react-router-dom'
import React from 'react'
import { parseJwt } from '../../utils/utils'
import { setUser } from '../../redux/slices/UserSlice'
import { useDispatch } from 'react-redux'
import { useGetUser } from '../../utils/utils'

export const UserControl: React.FC = () => {
	const tokenMatch = window.location.hash.match(/#id_token=(.+)/)
	const token = tokenMatch && tokenMatch[1] ? tokenMatch[1] : getSessionToken()
	const dispatch = useDispatch()

	const user = useGetUser(token)

	// Estrae il source dal token JWT
	let source = null
	if (token) {
		const jwtInfo = parseJwt(token)
		source = jwtInfo?.Source || null
	}

	if (token !== '') {
		setSessionToken(token)
		source === ATOL && sessionStorage.setItem('AtolUser', 'true')

		if (user) {
			dispatch(
				setUser({
					...user,
					source,
				}),
			)
		}
	}

	return <Navigate to="/home"></Navigate>
}
